import { AccessContext } from "./accessContext";
import { getCompanyDetail } from "./api/platform.service";

/** Logo of the company the session is in; a support session has no company link, so it reads the company itself. */
export const resolveCurrentCompanyLogo = async (
  ctx: AccessContext,
  user: any,
  listCompany: any
): Promise<string> => {
  const homeLogo = user?.company?.companyLogo || "";
  const currentId = ctx.currentCompanyId;
  if (!currentId || currentId === (ctx.homeCompanyId || user?.companyId)) return homeLogo;
  const linked = (Array.isArray(listCompany) ? listCompany : []).find(
    (v: any) => v?.company?.id === currentId
  )?.company;
  if (linked) return linked.companyLogo || "";
  if (ctx.mode !== "support") return "";
  try {
    const { data } = await getCompanyDetail(currentId);
    return data?.company?.id === currentId ? data.company.companyLogo || "" : "";
  } catch {
    return "";
  }
};
